import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../../types';

export const Route = createFileRoute('/_private-routes/tiktok/advertiser-details')({
  staticData: {
    menuTitle: MenuTitle.Account
  }
});
